// extracted by mini-css-extract-plugin
export default {"option":"Toggle_option__JokZd","selected":"Toggle_selected__eU6FU"};